/**
 * Created by dushyantha on 7/12/16.
 */
'use strict';

(function () {
  angular
    .module('crewSchedule')
    .component('userScheduleComponent', {
        templateUrl: 'crew-schedule/components/user-schedule-component.tpl.html',
        controller: function (CommonMasterData,EventManagerService, StorageServices, ApplicationService, TabService, ContextMenuService, MessageService, CrewingSelectionHelper, crewingConstants, CrewingHelper, PopupManager, $timeout, $scope, crewSchAssignTraningLogic, CommonLogicService) {
          var vm = this;
          vm.backgroundColor = '#cccccc'
          vm.selectetRowIndex = null;
          vm.min_screen_width = 1200;
          vm.screen_left_panel = 180;
          vm.screen_right_panel = 0;
          vm.comHeight = window.innerHeight - (70 + 42 + 40 + 80);
          vm.roster_section_width = 680;
          vm.detail_section_width = 560;
          vm.left_align = 71;
          vm.day_width = Math.floor(vm.roster_section_width / 7);
          vm.actual_screen_width = window.innerWidth;
          vm.actual_screen_height = window.innerHeight - 235; // 235 = header banners height + legend height
          vm.day_height = Math.floor(vm.actual_screen_height / 6);
          vm.block_height = Math.floor(vm.day_height * 35 / 100);
          vm.act_she_top_pos = vm.day_height - vm.block_height;
          vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;
          vm.calendar = [];
          vm.isBlockViewFlagEnable = false;
          vm.selectedDay = '';
          vm.selectedModul = null;
          vm.showAssignPairing = false;
          vm.showReplacePairing = false;
          vm.assignActionTypes = {
            PAIRING: 'pairing',
            EVENT: 'event',
            TRAINING: 'training'
          };
          vm.menuActioRelatedContent = {
            lastAction: null,
            cut: {
              cutActionSource: null
            },
            copy: {
              copyActionSource: null
            },
            daySelection: {
              selected: null
            }
          };
          EventManagerService.registerEventListener(EventManagerService.EVENT.SCREEN_SIZE_CHANGE, changeScreenListener);
          //  CONTEXT_MENU Listener
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ADD_MEMO, addMemoListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EDIT_BLOCK, editBlockListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EDIT_EVENT, editBlockListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EVENT, contextMenuAssignEventListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EVENT_OFC, onAssignEventOfcListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_OFF, onAssignOffListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_VOLUNTARILY_UNPAID_LEAVE, onAssignVoluntarilyUnpaidLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SICK_LEAVE, onAssignSickLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_ANNUAL_LEAVE, onAssignAnnualLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_BLOCK_DAYS, onAssignBlockDaysListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DELETE_BLOCK, deleteBlockListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_PAIRING, contextMenuAssignPairingListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_TRAINING, contextMenuAssignTrainingListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EMAIL_CREW, emailCrewScheduleListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ALERT, sendAlertListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.HISTORY, historyListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.REGULATION_DETAILS, regulationDetailsListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DESELECT_ALL, deselectAll);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EDIT_PAIRING, editPairingListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SMS, onSendSmsListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SEND_NOTIFICATION, onSendNotificationListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EVALUATE_TRAININGS, onEvaluateTrainingsListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.PAX_MSG_DETAILS, paxMsgDetailsListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.REPLACE_PARING, replacePairingListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DELAYED_REPORT_TIMING, delayedReportTimingListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.IGNORE_REGULATION_VIOLATION, onIgnoreViolationListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.REVERT_IGNORED_REGULATION_VIOLATION, onRestoreIgnoredViolationListener);

          //--------------------------Context Menu Sub Menu Listeners ------------------------------------------------
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_UNPAID_LEAVE, onAssignUnpaidLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EMERGENCY_LEAVE, onAssignEmergencyLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_IND_LEAVE, onAssignIndLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_HAJJ_LEAVE, onAssignHajjLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_COMPASSIONATE_LEAVE, onAssignCompassionateLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_MATERNITY_LEAVE, onAssignMaternityLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_PATERNITY_LEAVE, onAssignPaternityLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SUSPENSION_LEAVE, onAssignSuspensionLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_NOSHOW_LEAVE, onAssignNoShowLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_MARRIAGE_LEAVE, onAssignMarriageLeaveListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_UNPAID_SICK_LEAVE, onAssignUnpaidSickLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_ABSENT_LEAVE, onAssignAbsentLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_COMMUTING_LEAVE, onAssignCommutingLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SPECIAL_UNPAID_LEAVE, onAssignSpecialUnpaidLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_FM_LEAVE, onAssignFMLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_FLEXIBLE_SICK_LEAVE, onAssignFSLVLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SNY_LEAVE, onAssignSNYLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SICK_LEAVE, onAssignSickLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_WFD_LEAVE, onAssignWFDLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_AWB_LEAVE, onAssignAWBLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_LIM_LEAVE, onAssignLIMLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_VUNP_LEAVE, onAssignVUNPLeaveListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SBD_LEAVE, onAssignSBDLeaveListener);
          //TOOLBAR Listener
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ADD_MEMO, addMemoListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EDIT_BLOCK, editBlockListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ASSIGN_EVENT, toolbarAssignEventListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.DELETE_BLOCK, deleteBlockListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ASSIGN_PAIRING, toolbarAssignPairingListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ASSIGN_TRAINING, toolbarAssignTrainingListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EMAIL_CREW, emailCrewScheduleListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.SMS, onSendSmsListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ALERT, sendAlertListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.HISTORY, historyListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.REGULATION_DETAILS, regulationDetailsListener);
          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EDIT_PAIRING, editPairingListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS, onCollapseAllExpandRows);

          EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.SMS_MANAGER, onSmsManagerClick);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CNT, onAssignCntListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ACKNOWLEDGE_DUTY, contextMenuOnAcknowledgeListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CONVERT_TO_SICK, onConvertToSickListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SBY_CALL_OUT, contextMenuAssignSbyCallOutListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SECONDEDIN_OTHER_HUBS, onAssignSOHListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CABIN_SPECIAL_DUTY, onAssignCSDListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_CABIN_SUPPORT_ACTIVITY, onAssignCSAListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_AVAILABLE, onAssignAVLListener);

          EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_TO_BE_NOTIFIED, onAssignTBNListener);

          loadUserPreferencesForRightClickLeaveAssignment();
          loadUserPreferencesForRightClickEventAssignment();

          function onIgnoreViolationListener() {
            const duty = CrewingSelectionHelper.getSelectedDuty();
            if(CommonLogicService.isPastDuty(duty.checkInDate)) {
              PopupManager.openModal('IGNORE_REGULATION_VIOLATION', duty, refreshSchedule);
            } else {
              MessageService.error('Violations can be ignored only for past duties.');
            }
          }

          function onRestoreIgnoredViolationListener() {
            const duty = CrewingSelectionHelper.getSelectedDuty();
            PopupManager.openModal('RESTORE_REGULATION_VIOLATION', duty, refreshSchedule);
          }

          function refreshSchedule(params) {
            if (params) {
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.REFRESH);
            }
          }

          function onSmsManagerClick() {
            if (vm.crewDetails.crewId) {
              var tabName = 'smsManager';
              var crewScheduleData = { fromDate: vm.fromDate, toDate: vm.toDate, crewProfileId: vm.crewDetails.crewProfileId }
              StorageServices.setTabData(tabName, 'sms_manager_data_for_crew', crewScheduleData);
              TabService.gotoTab(tabName, crewScheduleData);
            }
          }

          // initialize roster view
          displayAdjustment();

          //Window resize event handling
          angular.element(window).on('resize', function () {
            $scope.$apply(function () {
              vm.actual_screen_width = window.innerWidth;
              vm.actual_screen_height = window.innerHeight - 235; // 235 = header banners height + legend height

              displayAdjustment();
            });
          });

          $scope.$on('showCrewProfilePanel', function (event, mass) {
            if (mass) {
              vm.detail_section_width = 560;
            } else {
              vm.detail_section_width = 5;
            }

            displayAdjustment();

            adaptActualScheduleData();
          });

          if ($(".tabbed-view-container").height() == 0)
            $(".tabbed-view-container").height(80);

          var height = ($("header").height() + $(".tabbed-view-container").height()) + "px";
          $(".canvas").css("top", height);

          vm.$onInit = function () {
            setCrewScheduleBlockViewFlagsEnable();
          };

          vm.$onChanges = function (changeObj) {
            if (changeObj.fromDate && changeObj.fromDate.currentValue && (changeObj.fromDate.currentValue != changeObj.fromDate.previousValue)) {
              generateCalendar();
            }
            else if (changeObj.toDate && changeObj.toDate.currentValue && (changeObj.toDate.currentValue != changeObj.toDate.previousValue)) {
              generateCalendar();
            }
            if (changeObj.crewActualSchedule && changeObj.crewActualSchedule.currentValue && (changeObj.crewActualSchedule.currentValue != changeObj.crewActualSchedule.previousValue)) {
              generateCalendar();
              adaptActualScheduleData();
              CrewingSelectionHelper.crewNamesCol(vm.crewActualSchedule.nameCollection);
              CrewingSelectionHelper.setCrewSchedule(vm.crewActualSchedule);
              CrewingSelectionHelper.clearSelections();
            }
            if (changeObj.crewPublishSchedule && changeObj.crewPublishSchedule.currentValue && (changeObj.crewPublishSchedule.currentValue != changeObj.crewPublishSchedule.previousValue)) {
              adaptPublishScheduleData()
            }
          };

          vm.onBlockClick = function (day, actSchedule, eventDetails, week, rowIndex, event) {
            vm.selectetRowIndex = week.rowIndex;
            var context = {
              crews: vm.crewDetails,
              patterns: eventDetails,
              block: actSchedule,
              week: week
            };
            if (event.ctrlKey) {
              CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
            } else if (event.shiftKey) {
              CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.SHIFT_CLICK, context);
            } else {
              CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.SCHEDULE_BLOCK, CrewingSelectionHelper.INTERACTION.CLICK, context);
            }
            /*eventDetails.isSelected =true
             CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
             crews: vm.crewDetails,
             block: actSchedule
             });*/
          };

          vm.onBlockRightClick = function (childScope, day) {

            const event_type = childScope.$parent.actSchedule.evenCode;
            const crew_schedule_block_id = childScope.$parent.actSchedule.crewScheduleBlockId;

            // vm.selectedDay = clickedScope.day;
            // vm.selectetRowIndex = clickedScope.$parent.rosterDay.rowIndex;
            // CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.SCHEDULE_DAY, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
            //   days: clickedScope.day,
            //   crews: vm.crewActualSchedule.schedule[0],
            //   week: clickedScope.$parent.rosterDay
            // });
            let blockType = null;
            if (event_type === "SBY" || event_type === "HSBY" || event_type === "ASBY") {
              blockType = "SBY";
            }

            vm.selectetRowIndex = childScope.$parent.rosterDay.rowIndex;
            var pattern = childScope.$parent.day.actualSchedule[0];
            if (childScope.$parent.day.actualSchedule.length > 1) {
              pattern = childScope.$parent.day.actualSchedule[childScope.$parent.day.actualSchedule[0].length - 1];
            }
            CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.SCHEDULE_BLOCK, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
              days: day,
              crews: vm.crewDetails,
              patterns: pattern,
              block: childScope.actSchedule,
              week: childScope.$parent.rosterDay
            });

          };

          vm.onBlockHover = function (e, block) {
            vm.blockToolTiop = block;
            var findCheckPosition = function () {
              var H = 'left', V = 'top';
              if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                H = 'left';
              } else {
                H = 'right';
              }
              if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                V = 'bottom';
              } else {
                V = 'top';
              }
              return H + '-' + V;
            };

            vm.toolTipPosition = findCheckPosition();
          };

          function displayAdjustment() {
            if (!!vm.actual_screen_width && vm.actual_screen_width > vm.min_screen_width) {
              vm.roster_section_width = vm.actual_screen_width - vm.detail_section_width - vm.left_align;
              vm.day_width = Math.floor(vm.roster_section_width / 7 * 10) / 10;
              vm.minuteToPixelRatio = vm.day_width / (24 * 60);
              vm.screen_right_panel = vm.actual_screen_width - vm.screen_left_panel;
            }
          }

          function setCrewScheduleBlockViewFlagsEnable() {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
              vm.isBlockViewFlagEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
            });
          }

          function generateCalendar() {
            vm.calendar = [];
            vm.weekDays = moment.weekdaysShort(true);
            vm.cal_start = moment(vm.fromDate, "DD/MM/YYYY");
            vm.cal_end = moment(vm.toDate, 'DD/MM/YYYY');

            vm.noOfDays = vm.cal_end.diff(vm.cal_start, 'days') + 1;

            var month = vm.cal_start.format('MM');
            var year = vm.cal_start.format('YYYY');
            var calenderEnd = '';
            var calendarStart = moment('01/' + month + '/' + year, "DD/MM/YYYY");
            var monthEnd = moment(vm.cal_start).endOf('month');
            if (vm.cal_end.isAfter(monthEnd)) {
              calenderEnd = vm.cal_end;
            }
            else {
              calenderEnd = monthEnd;
            }

            //  var range = moment().range(vm.cal_start, vm.cal_end);

            /* if (date.isBefore(endDate)
             && date.isAfter(startDate)
             || (date.isSame(startDate) || date.isSame(endDate))
             ) {
             alert("Yay!");
             } else {
             alert("Nay! :(");
             }*/

            //                    var diff=vm.cal_start.diff(vm.cal_end);
            //var diff=calendarStart.diff(calenderEnd);

            var dateDiff = calenderEnd.diff(calendarStart, 'days');
            var tempCalendar = [];
            var currDate = moment().format("DD/MM/YYYY");
            for (var i = 0; i <= dateDiff; i++) {
              var tmp = moment(calendarStart).add(i, 'd');
              var isCurrentDate = (currDate === tmp.format('DD/MM/YYYY'));
              var isDisable = true;
              if (tmp.isBefore(vm.cal_end)
                && tmp.isAfter(vm.cal_start)
                || (tmp.isSame(vm.cal_start) || tmp.isSame(vm.cal_end))
              ) {
                isDisable = false;
              }

              tempCalendar.push({
                date: tmp.format('DD/MM/YYYY'),
                dayReference: tmp.format('YYYYMMDD'),
                isSelected: false,
                actualSchedule: [],
                publishSchedule: [],
                alertDetails: [],
                memoDetails: [],
                expiry: [],
                isCurrentDate: isCurrentDate,
                dayIndex: i,
                isDisable: isDisable

              });
            }

            var starIndex = vm.weekDays.indexOf(calendarStart.format('ddd'));
            if (starIndex !== 0) {
              for (var i = 0; i < starIndex; i++) {
                tempCalendar.unshift({
                  date: 0,
                  dayReference: 0,
                  isSelected: false,
                  actualSchedule: [],
                  publishSchedule: [],
                  alertDetails: [],
                  memoDetails: [],
                  expiry: [],
                  isCurrentDate: false,
                  dayIndex: '',
                  isDisable: true

                });
              }
            }
            var endIndex = vm.weekDays.indexOf(calenderEnd.format('ddd'));
            if (endIndex !== 6) {
              for (var j = 0; j < (6 - endIndex); j++) {
                tempCalendar.push({
                  date: 0,
                  dayReference: 0,
                  isSelected: false,
                  actualSchedule: [],
                  publishSchedule: [],
                  alertDetails: [],
                  memoDetails: [],
                  expiry: [],
                  isCurrentDate: false,
                  dayIndex: '',
                  isDisable: true
                });
              }

            }
            var t = 0;
            vm.originalCal = angular.copy(tempCalendar)
            for (var k = 0; k < tempCalendar.length; k += 7) {
              var temp = [];
              var j = 0;
              for (j; j < 7; j++) {
                temp.nextWeekStart = '';
                temp.rowIndex = t;
                temp[temp.length] = tempCalendar[k + j];
                if (j === 0 && k !== 0) {
                  vm.calendar[t].nextWeekStart = tempCalendar[k + j].date;
                  t = t + 1;
                }
              }
              vm.calendar[vm.calendar.length] = temp
            }
            CrewingSelectionHelper.setTimeLineDaysCol(vm.calendar);
          }

          function getPositionFromDate(date, time, relativeTo) {
            var reqDate = date + ' ' + time;
            var reqDateTime = moment(reqDate, 'DD/MM/YYYY HH:mm');
            var relativeDate = moment(relativeTo, 'DD/MM/YYYY');
            var diffFromStart = reqDateTime.diff(relativeDate, 'm');
            return Math.round(diffFromStart * vm.minuteToPixelRatio);
          }

          function adaptActualScheduleData() {
            // vm.crewSchedule = _.groupBy(vm.crewSchedule,'checkInDate');
            mapScheduleWithCalendar();
            mapAlertsWithCalendar();
            mapMemosWithCalendar();
            mapExpiryWithCalendar();
          }

          function mapScheduleWithCalendar() {
            if (vm.crewActualSchedule.schedule.length > 0) {
              angular.forEach(vm.crewActualSchedule.schedule[0].adaptedRosterDutyDTOs, function (schedule, scheduleIndex) {
                angular.forEach(vm.calendar, function (row, key) {
                  row.isExpand = false;
                  angular.forEach(row, function (day) {

                    if (schedule.patternStartDate === day.date) {

                      schedule.leftPos = getPositionFromDate(schedule.patternStartDate, schedule.patternStartTime, schedule.patternStartDate);
                      var endPos = getPositionFromDate(schedule.patternEndDate, schedule.patternEndTime, schedule.patternStartDate);
                      schedule.width = endPos - schedule.leftPos;
                      if (schedule.events.length) {
                        angular.forEach(schedule.events, function (event) {
                          if (event.type === "REST") {
                            event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, schedule.patternStartDate);
                            var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, schedule.patternStartDate);
                            event.width = endPos - event.leftPos;
                            event.minimumRest = vm.minuteToPixelRatio * event.minRest;
                          }
                          else {
                            event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, schedule.patternStartDate);
                            var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, schedule.patternStartDate);
                            event.width = endPos - event.leftPos;
                          }


                        });
                      }
                      day.actualSchedule.push(schedule);

                      /*if (moment(schedule.patternEndDate, 'DD/MM/YYYY').diff(moment(row.nextWeekStart, 'DD/MM/YYYY')) >= 0 || moment(schedule.restEndDate, 'DD/MM/YYYY').diff(moment(row.nextWeekStart, 'DD/MM/YYYY')) >= 0) {
                       if (vm.calendar[key + 1] !== undefined) {
                       var tempSchedule = angular.copy(schedule);
                       tempSchedule.leftPos = getPositionFromDate(tempSchedule.patternStartDate, tempSchedule.patternStartTime, row.nextWeekStart);
                       var endPos = getPositionFromDate(tempSchedule.patternEndDate, tempSchedule.patternEndTime, row.nextWeekStart);
                       tempSchedule.width = endPos - tempSchedule.leftPos;
                       if (tempSchedule.events.length) {
                       angular.forEach(tempSchedule.events, function (event) {
                       if (event.type === "REST") {
                       event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, row.nextWeekStart);
                       var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, row.nextWeekStart);
                       event.width = endPos - event.leftPos;
                       }
                       else {
                       event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, row.nextWeekStart);
                       var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, row.nextWeekStart);
                       event.width = endPos - event.leftPos;
                       }
                       });
                       }
                       vm.calendar[key + 1][0].actualSchedule.push(tempSchedule);
                       }
                       }*/

                      for (var i = key; i < vm.calendar.length; i++) {
                        var nextWeekStart = vm.calendar[i].nextWeekStart;
                        if (nextWeekStart != "" && (moment(schedule.patternEndDate, 'DD/MM/YYYY').diff(moment(nextWeekStart, 'DD/MM/YYYY')) >= 0 || moment(schedule.restEndDate, 'DD/MM/YYYY').diff(moment(nextWeekStart, 'DD/MM/YYYY')) >= 0)) {
                          if (vm.calendar[i + 1] !== undefined) {
                            var tempSchedule = angular.copy(schedule);
                            tempSchedule.leftPos = getPositionFromDate(tempSchedule.patternStartDate, tempSchedule.patternStartTime, nextWeekStart);
                            var endPos = getPositionFromDate(tempSchedule.patternEndDate, tempSchedule.patternEndTime, nextWeekStart);
                            tempSchedule.width = endPos - tempSchedule.leftPos;
                            if (tempSchedule.events.length) {
                              angular.forEach(tempSchedule.events, function (event) {
                                if (event.type === "REST") {
                                  event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, nextWeekStart);
                                  var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, nextWeekStart);
                                  event.width = endPos - event.leftPos;
                                }
                                else {
                                  event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, nextWeekStart);
                                  var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, nextWeekStart);
                                  event.width = endPos - event.leftPos;
                                }
                              });
                            }
                            vm.calendar[i + 1][0].actualSchedule.push(tempSchedule);//set next week value
                          }
                        }
                      }
                    }
                    else {
                      if ((_.find(vm.originalCal, { date: schedule.patternStartDate }) === undefined) && schedule.patternEndDate === day.date) {
                        schedule.leftPos = getPositionFromDate(schedule.patternStartDate, schedule.patternStartTime, day.date);
                        var endPos = getPositionFromDate(schedule.patternEndDate, schedule.patternEndTime, day.date);
                        schedule.width = endPos - schedule.leftPos;
                        if (schedule.events.length) {
                          angular.forEach(schedule.events, function (event) {
                            if (event.type === "REST") {
                              event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, day.date);
                              var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, day.date);
                              event.width = endPos - event.leftPos;
                            }
                            else {
                              event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, day.date);
                              var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, day.date);
                              event.width = endPos - event.leftPos;
                            }


                          });
                        }
                        day.actualSchedule.push(schedule);

                        for (var i = key; i > 0; i--) {
                          var previousWeekEnd = vm.calendar[i - 1][6].date;
                          if (previousWeekEnd != "" && (moment(previousWeekEnd, 'DD/MM/YYYY').diff(moment(schedule.patternStartDate, 'DD/MM/YYYY')) >= 0 || moment(previousWeekEnd, 'DD/MM/YYYY').diff(moment(schedule.restStartDate, 'DD/MM/YYYY')) >= 0)) {
                            if (vm.calendar[i - 1] !== undefined) {
                              var tempSchedule = angular.copy(schedule);
                              tempSchedule.leftPos = getPositionFromDate(tempSchedule.patternStartDate, tempSchedule.patternStartTime, previousWeekEnd);
                              var endPos = getPositionFromDate(tempSchedule.patternEndDate, tempSchedule.patternEndTime, previousWeekEnd);
                              tempSchedule.width = endPos - tempSchedule.leftPos;
                              if (tempSchedule.events.length) {
                                angular.forEach(tempSchedule.events, function (event) {
                                  if (event.type === "REST") {
                                    event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, previousWeekEnd);
                                    var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, previousWeekEnd);
                                    event.width = endPos - event.leftPos;
                                  }
                                  else {
                                    event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, previousWeekEnd);
                                    var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, previousWeekEnd);
                                    event.width = endPos - event.leftPos;
                                  }
                                });
                              }
                              vm.calendar[i - 1][6].actualSchedule.push(tempSchedule);//set next week value
                            }
                          }
                        }
                      }

                    }
                  });
                });

              });
            }
          }

          function mapAlertsWithCalendar() {
            angular.forEach(vm.calendar, function (row, key) {
              angular.forEach(row, function (day) {
                if (!!day.alertDetails) {
                  day.alertDetails = [];
                }

              });
            });
            angular.forEach(vm.alertsDetails, function (alert) {
              angular.forEach(vm.calendar, function (row, key) {
                angular.forEach(row, function (day) {
                  if (alert.alertDate === day.date) {
                    day.alertDetails.push(alert);
                  }

                });
              });
            });
          }

          function mapMemosWithCalendar() {
            angular.forEach(vm.calendar, function (row, key) {
              angular.forEach(row, function (day) {
                day.memoDetails = [];
              });
            });
            angular.forEach(vm.memoDetails, function (memo) {
              angular.forEach(vm.calendar, function (row, key) {
                angular.forEach(row, function (day) {
                  if (memo.memoDate === day.date) {
                    var temp = day.memoDetails.indexOf(memo);
                    day.memoDetails.push(memo);
                  }

                });
              });
            });
          }

          function mapExpiryWithCalendar() {
            angular.forEach(vm.calendar, function (row, key) {
              angular.forEach(row, function (day) {
                day.expiry = [];

              });
            });
            angular.forEach(vm.crewDetails.crewExpiryDTOs, function (expiry) {
              angular.forEach(vm.calendar, function (row, key) {
                angular.forEach(row, function (day) {
                  if (expiry.dateOfExpiry === day.date) {
                    day.expiry.push(expiry);
                  }

                });
              });
            });
          }

          function adaptPublishScheduleData() {
            angular.forEach(vm.crewPublishSchedule, function (schedule) {
              angular.forEach(vm.calendar, function (row, key) {
                angular.forEach(row, function (day) {
                  if (schedule.checkinDate === day.date) {
                    schedule.leftPos = getPositionFromDate(schedule.checkinDate, schedule.checkinTime, schedule.checkinDate);
                    var endPos = getPositionFromDate(schedule.checkOutDate, schedule.checkOutTime, schedule.checkinDate);
                    schedule.width = endPos - schedule.leftPos;

                    if (!!schedule.restStartDate) {
                      schedule.restLeftPos = getPositionFromDate(schedule.restStartDate, schedule.restStartTime, schedule.checkinDate);
                      var restEndPos = getPositionFromDate(schedule.restEndDate, schedule.restEndTime, schedule.checkinDate);
                      schedule.restWidth = restEndPos - schedule.restLeftPos;
                    }
                    day.publishSchedule.push(schedule);
                    if (moment(schedule.checkOutDate, 'DD/MM/YYYY').diff(moment(row.nextWeekStart, 'DD/MM/YYYY')) >= 0 || moment(schedule.restEndDate, 'DD/MM/YYYY').diff(moment(row.nextWeekStart, 'DD/MM/YYYY')) >= 0) {
                      if (vm.calendar[key + 1] !== undefined) {
                        var tempSchedule = angular.copy(schedule);
                        tempSchedule.leftPos = getPositionFromDate(tempSchedule.checkinDate, tempSchedule.checkinTime, row.nextWeekStart);
                        var endPos = getPositionFromDate(tempSchedule.checkOutDate, tempSchedule.checkOutTime, row.nextWeekStart);
                        tempSchedule.width = endPos - tempSchedule.leftPos;

                        if (!!tempSchedule.restStartDate) {
                          tempSchedule.restLeftPos = getPositionFromDate(tempSchedule.restStartDate, tempSchedule.restStartTime, row.nextWeekStart);
                          var restEndPos = getPositionFromDate(tempSchedule.restEndDate, tempSchedule.restEndTime, row.nextWeekStart);
                          tempSchedule.restWidth = restEndPos - tempSchedule.restLeftPos;

                        }
                        vm.calendar[key + 1][0].publishSchedule.push(tempSchedule);
                      }
                    }
                  }
                });
              });
            });
          }

          vm.clickOnMonthNavigation = function (option) {
            vm.monthNavigation({ 'type': option })
            onCollapseAllExpandRows();
          };

          vm.onMemoClick = function (memo) {
            memo.status = vm.crewDetails.active;
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.OPEN_MEMO, memo);
          };

          vm.onDaySelected = function (rosterDay, day, rowIndex, event) {
            vm.selectedDay = day;
            vm.selectetRowIndex = rosterDay.rowIndex;
            var context = {
              days: day,
              crews: vm.crewActualSchedule.schedule[0],
              crewNames: _.find(vm.crewActualSchedule.nameCollection, { crewId: vm.crewDetails.crewId }),
              week: rosterDay,
              userEvent: event
            };
            if (event.shiftKey) {
              CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.SHIFT_CLICK, context);
            } else if (event.ctrlKey) {
              CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
            } else {
              CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.SCHEDULE_DAY, CrewingSelectionHelper.INTERACTION.CLICK, context);
            }

            loadTrainings();
          };

          vm.onDayRightClick = function (clickedScope) {
            vm.selectedDay = clickedScope.day;
            vm.selectetRowIndex = clickedScope.$parent.rosterDay.rowIndex;
            CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.SCHEDULE_DAY, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
              days: clickedScope.day,
              crews: vm.crewActualSchedule.schedule[0],
              week: clickedScope.$parent.rosterDay
            });
          };

          vm.cancelEvent = function (event) {
            event.stopPropagation();
          };

          vm.getContextMenu = function (type, duty) {
            /* if (type == 'dut') {
             if (!!duty.patternId) {
             return ContextMenuService.getContextMenu('DUTY_IN_PAIRING');
             } else {
             return ContextMenuService.getContextMenu('DUTY');
             }
             } else if (type == 'date') {
             return ContextMenuService.getContextMenu('DATE');
             }*/

            var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
            var selectedDays = CrewingSelectionHelper.getSelectedDays();
            var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
            /*if (!!vm.menuActioRelatedContent.cut.cutActionSource) {
             return ContextMenuService.getContextMenu('CUT');
             }

             if (!!vm.menuActioRelatedContent.copy.copyActionSource) {
             return ContextMenuService.getContextMenu('COPY');
             }*/

            if (type == 'duty') {
              var showOrHide = duty.showInCrewPortal ? 'VISIBILITY_HIDE' : 'VISIBILITY_SHOW';
              var visibilityMenu = (vm.isBlockViewFlagEnable) ? ContextMenuService.getContextMenu(showOrHide) : [];
              var isDutyChangedNotification = duty.acknowledgableDuty;
              if (isDutyChangedNotification){
                var acknowledgeContextMenu = ContextMenuService.getContextMenu('ACKNOWLEDGE_DUTY');
                visibilityMenu = visibilityMenu.concat(acknowledgeContextMenu)
              }
              console.log(JSON.stringify(duty));
              if (duty.blockName == "SWO" || duty.blockName == "SWA"){
                var convertBackToSickContextMenu = ContextMenuService.getContextMenu('SWO');
                visibilityMenu = visibilityMenu.concat(convertBackToSickContextMenu)
              }

              var otherMenu = [];

              if (!!duty.trainingSlotId) {
                var updateResultsOption = ContextMenuService.getContextMenu('UPDATE_RESULTS');
                visibilityMenu = visibilityMenu.concat(updateResultsOption);
              }

              if (duty.illegalDistIdentifier) {
                otherMenu = ContextMenuService.getContextMenu('SHOW_VIOLATION');
              }

              if (selectedBlocks.length > 1) {
                return ContextMenuService.getContextMenu('DELETE').concat(visibilityMenu).concat(otherMenu);
              } else if (!!duty.patternId) {

                if(duty.violationsIgnored) {
                  const restoreIgnoredViolationContextMenu = ContextMenuService.getContextMenu('RESTORE_IGNORED_VIOLATION');
                  visibilityMenu = visibilityMenu.concat(restoreIgnoredViolationContextMenu);
                } else if (!duty.legal) {
                  const ignoreViolationContextMenu = ContextMenuService.getContextMenu('IGNORE_VIOLATION');
                  visibilityMenu = visibilityMenu.concat(ignoreViolationContextMenu);
                }

                if (selectedBlocks.length > 0) {
                  if (selectedBlocks[0].events.length > 0) {
                    if (selectedBlocks[0].events[0]["evenCode"] == "SBY" || selectedBlocks[0].events[0]["evenCode"] == "HSBY" || selectedBlocks[0].events[0]["evenCode"] == "ASBY") {
                      var sbyContextMenu = ContextMenuService.getContextMenu('SCHEDULE_SBY_EVENT');
                      return ContextMenuService.getContextMenu('SCHEDULE_DUTY_IN_PAIRING').concat(visibilityMenu).concat(otherMenu).concat(sbyContextMenu);
                    }
                  }
                }
                return ContextMenuService.getContextMenu('SCHEDULE_DUTY_IN_PAIRING').concat(visibilityMenu).concat(otherMenu);
              } else {
                //return ContextMenuService.getContextMenu('SCHEDULE_DUTY');
                if (CrewingHelper.isLeaveBlock(selectedBlocks[0])) {
                  return ContextMenuService.getContextMenu('SCHEDULE_LEAVE').concat(visibilityMenu).concat(otherMenu);
                } else {
                  if(duty.violationsIgnored) {
                    const restoreIgnoredViolationContextMenu = ContextMenuService.getContextMenu('RESTORE_IGNORED_VIOLATION');
                    visibilityMenu = visibilityMenu.concat(restoreIgnoredViolationContextMenu);
                  } else if (!duty.legal) {
                    const ignoreViolationContextMenu = ContextMenuService.getContextMenu('IGNORE_VIOLATION');
                    visibilityMenu = visibilityMenu.concat(ignoreViolationContextMenu);
                  }

                  if (!duty.trainingSlotId) {
                    const event_code = duty.evenCode;
                    if (event_code === "SBY" || event_code === "HSBY" || event_code === "ASBY") {
                      var sbyContextMenu = ContextMenuService.getContextMenu('SCHEDULE_SBY_EVENT');
                      return ContextMenuService.getContextMenu('SCHEDULE_EVENT').concat(visibilityMenu).concat(otherMenu).concat(sbyContextMenu);
                    } else {
                      return ContextMenuService.getContextMenu('SCHEDULE_EVENT').concat(visibilityMenu).concat(otherMenu);
                    }
                  }
                  return ContextMenuService.getContextMenu('SCHEDULE_EVENT_IN_PAIRING').concat(visibilityMenu).concat(otherMenu);
                }
              }
            } else if (type == 'date') {
              if (selectedDays.length > 1) {
                return ContextMenuService.getContextMenu('MULTIPLE_DAY_SELECTION');
              }
              return ContextMenuService.getContextMenu('DATE');
            } else if (type == 'crew') {
              if (selectedCrews.length > 1) {
                return ContextMenuService.getContextMenu('MULTIPLE_CREW_SELECTION');
              } else {
                return ContextMenuService.getContextMenu('CREW');
              }
            }
          };

          vm.deleteCrewDuty = function (event) {
            if (event.key === "Delete") {
              deleteBlockListener();
            }
          };

          vm.test = function () {
            MessageService.success("Test delete!");
          }

          function loadTrainings(selectedDate) {
            crewSchAssignTraningLogic.loadTrainingsForCrew(
              vm.crewDetails,
              vm.selectedDay && vm.selectedDay.date,
              vm.selectedDay && vm.selectedDay.date);
          };

          function addMemoListener() {
            var _param = vm.selectedDay;
            if (_param !== null) {
              vm.onAddMemo.call(this, { params: _param });
            } else {
              MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
            }
          }

          function editBlockListener(param) {
            // var crewSelection = CrewingSelectionHelper.getSelectedCrews();
            var selectedDuty = CrewingSelectionHelper.getSelectedDuty();
            var selectedWeek = CrewingSelectionHelper.getWeekData();
            if (!!param && !selectedDuty) {
              selectedDuty = param;
            }

            if (!!selectedDuty) {
              var _param = {
                duty: selectedDuty,
                crew: vm.crewActualSchedule.schedule[0],
                //container: '#crewName_' + vm.crewDetails.crewId + '_' + vm.selectetRowIndex
                container: '#crewName_pairing_assign'
              };


              if (!!_param.duty.eventId && ((!!_param.duty.blockDetailCount && _param.duty.blockDetailCount === 1) || (_param.duty.patternId === 0 || _param.duty.patternId === null))) {
                if (_param.duty.updatableEvent) {
                  CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.WEEK, CrewingSelectionHelper.INTERACTION.EXPAND, {
                    week: selectedWeek[0]
                  });
                  vm.isExpandName = true;
                  vm.day_height = (Math.floor(vm.actual_screen_height / 6)) * 0.5;
                  vm.block_height = Math.floor(vm.day_height * 35 / 100);
                  vm.act_she_top_pos = vm.day_height - vm.block_height;
                  vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;

                  vm.onEditBlock.call(this, { params: _param });
                } else {
                  MessageService.warning(MessageService.MESSAGES.CREWING.NOT_UPDATABLE_EVENT);
                }
              } else {
                vm.showingCrewProfile = true;
                vm.onEditBlock.call(this, { params: _param });
              }
            } else {
              MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
            }
          }

          function onCollapseAllExpandRows() {
            CrewingSelectionHelper.clearWeekRowExpands();

            vm.isExpandName = false;
            changeScreenListener();

          }


			function replacePairingListener() {
                  var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                  var selectedDuty = CrewingSelectionHelper.getSelectedDuty();


                  if (!!crewSelection && !!selectedDuty) {
                    var _param = {
                      duty: selectedDuty,
                      crew: crewSelection[0],
                      crews: crewSelection[0],
                      container: '#crewName_pairing_replace'
                    };

                    if(!!_param.duty.eventId && ! _param.duty.updatableEvent){
                      MessageService.warning(MessageService.MESSAGES.CREWING.NOT_UPDATABLE_EVENT);
                    }

                    if (!!_param.duty.eventId && ((!!_param.duty.blockDetailCount && _param.duty.blockDetailCount===1) || (_param.duty.patternId === null))){
                      //if (!!_param.duty.eventId && _param.duty.blockDetailCount ===1) {
                      if (_param.duty.updatableEvent) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.ROW, CrewingSelectionHelper.INTERACTION.EXPAND, {
                          crews: _param.crew
                        });
                        vm.isExpandReplace = true;
                        vm.day_height = (Math.floor(vm.actual_screen_height / 6))  * 0.5;
                        vm.block_height = Math.floor(vm.day_height * 35 / 100);
                        vm.act_she_top_pos = vm.day_height - vm.block_height;
                        vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;
                        vm.onReplacePairing.call(this, {params: _param});
                      } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NOT_UPDATABLE_EVENT);
                      }
                    } else {
                      vm.isExpandReplace = true;
                      vm.day_height = (Math.floor(vm.actual_screen_height / 6))  * 0.5;
                      vm.block_height = Math.floor(vm.day_height * 35 / 100);
                      vm.act_she_top_pos = vm.day_height - vm.block_height;
                      vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;
                      vm.onReplacePairing.call(this, {params: _param});
                    }
                  } else {
                    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                  }
                }

          function contextMenuAssignEventListener() {
            assignAction(vm.assignActionTypes.EVENT);
          }

          function toolbarAssignEventListener() {
            if(vm.crewDetails.active) assignAction(vm.assignActionTypes.EVENT);
            else MessageService.warning(MessageService.MESSAGES.CREWING.INACTIVE_CREW_WARNING);

          }

          function deleteBlock(param) {
            if (!!param) {
              var blocks = CrewingSelectionHelper.getSelectedBlocks();
              var toBeDeleted = CrewingHelper.getDutyAndCrewCollectionFromSelectedBlocks(blocks);
              vm.onBlockDelete({ blocks: toBeDeleted });
            }
          }

          function deleteBlockListener() {
            var blocks = CrewingSelectionHelper.getSelectedBlocks();
            if(vm.crewDetails.active) {
              if (blocks.length > 0) {
                var signed = false;
                var callOutPairing = false;
                for (let i = 0; i < blocks[0].events.length; i++) {

                  if(blocks[0].events[i].callOutReferenceCrewSchdBlockId !=null && blocks[0].events[i].callOutReferenceCrewSchdBlockId !=0){
                    callOutPairing =true;
                  }
                  if(blocks[0].events[i].signed){
                    signed = true;
                  }
                }
                var details = {};

                if(signed) {
                  details = {
                    title: 'Confirmation',
                    messages: ['Crew has already signed in for the duty. Do you wish to Continue?']

                  };
                }else{

                  if(callOutPairing){
                    details = {
                      title: 'Confirmation',
                      messages: ['Are you sure, You want to remove standby call out pairing. Do you wish to Continue? ']

                    };
                  }else{
                    details = {
                      title: 'Confirmation',
                      messages: ['Selected record will be Deleted. Do you wish to Continue?']

                    };
                  }

                }
                PopupManager.openModal('CONFIRM_DIALOG', details, deleteBlock);

              } else {
                MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
              }
            } else {
              MessageService.warning(MessageService.MESSAGES.CREWING.INACTIVE_CREW_WARNING);
            }
          }

          function getContextMenuClickData(data) {
            var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
            var selectedDays = CrewingSelectionHelper.getSelectedDays();
            var tmp = {
              crewProfileId: selectedCrews[0].crewDTO.crewProfileId,
              crewId: selectedCrews[0].crewId,
              crewName: selectedCrews[0].crewDTO.firstName + ' ' + selectedCrews[0].crewDTO.lastName,
              isOnProbation: selectedCrews[0].crewDTO.isOnProbation,
              dateClicked: selectedDays[0].date,
              isMultiple: false,
              selectedBase:data.selectedBase,
              forceAssignLeave: false
            };

            if (selectedDays.length == 1) {
              tmp.startDate = selectedDays[0].date;
              tmp.endDate = selectedDays[0].date;;
            } else if (selectedDays.length > 1) {
              var sorted = _.sortBy(selectedDays, function (obj) {
                return obj.dayIndex;
              });
              tmp.startDate = sorted[0].date;
              tmp.endDate = sorted[sorted.length - 1].date;
              tmp.isMultiple = true;

              var isFirst = true;
              var previous = null;
              var customSelectedDates = false
              for (var i = 0; i < sorted.length; i++) {

                if (isFirst) {
                  isFirst = !isFirst;
                  previous = sorted[i];
                  continue;
                }

                var current = sorted[i];
                const date1 = moment(previous.date, "DD/MM/YYYY");
                const date2 = moment(current.date, "DD/MM/YYYY");
                const diffTime = Math.abs(date2 - date1);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                if (diffDays >= 1) {
                  customSelectedDates = true;
                  break;
                }
              };

              if (customSelectedDates) {
                tmp.isCustomSelectedDates = true;
                tmp.customSelectedDates = [];

                var sorted = _.sortBy(selectedDays, function (obj) {
                  return obj.dayIndex;
                });

                angular.forEach(sorted, function (value, key) {
                  tmp.customSelectedDates.push(value.date);
                });
              }
            }

            return tmp;
          }

          function getSelectedFirstDayAndFirstCrew() {
            var daySelection = CrewingSelectionHelper.getSelectedDays();
            var crewSelection = CrewingSelectionHelper.getSelectedCrews();

            if (daySelection && daySelection.length > 0 && crewSelection && crewSelection.length > 0) {
              var _params = {
                day: daySelection[0],
                crew: crewSelection[0]
              };
              return _params;
            }
            return null;
          }

          function onAssignCntListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.cnt })
          }
          function onAssignSOHListener(data) {
            var _param = getContextMenuClickData(data);
            _param["selectedBase"] = data.selectedBase;
            vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.secondedinOtherHubs})
          }

          function onAssignCSDListener(data) {
            var _param = getContextMenuClickData(data);
            _param["selectedBase"] = data.selectedBase;
            vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.cabinSpecialDuty})
          }

          function onAssignCSAListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.cabinSupportActivity})
          }

          function onAssignAVLListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.available})
          }

          function onAssignTBNListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.toBeNotified})
          }

          function onAssignOffListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.off })
          }

          function onAssignEventOfcListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.officeDuty })
          }

          function onAssignVoluntarilyUnpaidLeaveListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.vulvLeave })
          }
          //--------------------------------------------------------------------------------------//
          function onAssignUnpaidLeaveListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.ulvLeave })
          }

          function onAssignEmergencyLeaveListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.elvLeave })
          }
          function onAssignIndLeaveListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.indLeave })
          }
          function onAssignHajjLeaveListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.hajLeave })
          }

          function onAssignCompassionateLeaveListener(data) {
            var _param = getContextMenuClickData(data);
            vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.comLeave })
          }
          function onAssignMaternityLeaveListener(data) {
            var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.matLeave })
        }
        function onAssignPaternityLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.patLeave })
        }
        function onAssignUnpaidSickLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.uslLeave })
        }
        function onAssignMarriageLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.marLeave })
        }
        function onAssignSuspensionLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.susLeave })
        }
        function onAssignNoShowLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.nshLeave })
        }
        function onAssignAbsentLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.absLeave })
        }
        function onAssignCommutingLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.clvLeave })
        }
        function onAssignSpecialUnpaidLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.sulvLeave })
        }
        function onAssignFMLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.fmLeave })
        }
        function onAssignFSLVLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.fslvLeave })
        }
        function onAssignSNYLeaveListener(data) {
          var _param = getContextMenuClickData(data);
          vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.snyLeave })
        }

          function contextMenuAssignSbyCallOutListener() {
            sbyCallOut();
          }



        //------------------------------------------------------------------------------------------//

          function sbyCallOut() {
            var _params = getSelectedDayAndCrew()
            if (_params !== null) {
              CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.WEEK, CrewingSelectionHelper.INTERACTION.EXPAND, {
                crews: _params.crew[0],
                week: _params.week[0]
              });

              _params.container = '#crewName_pairing_assign';


              vm.onSbyCallout({ params: _params,setPopUpSizeWhenSBYCallOut:setPopUpSizeWhenSBYCallOut });
            }
          }

          function setPopUpSizeWhenSBYCallOut() {
            vm.isExpandName = true;
            vm.day_height = (Math.floor(vm.actual_screen_height / 6)) * 0.5;
            vm.block_height = Math.floor(vm.day_height * 35 / 100);
            vm.act_she_top_pos = vm.day_height - vm.block_height;
            vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;
          }

        function checkProbation(crewInfo, eventType) {
          if (crewInfo.isOnProbation == 'Y') {
            var details = {
              title: 'Confirmation',
              messages: [MessageService.MESSAGES.CREWING.CREW_PROBATION_OVERRIDE,
                "Crew Details:",
                "Id:" + crewInfo.crewId,
                "Name: " + crewInfo.crewName],
              close: 'CLOSE'
            };
            PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignDirectAction);
          } else {
            confirmAssignDirectAction('NO');
            // vm.onDirectAction({ param: crewInfo, type: crewingConstants.EVENT_TYPES.sickLeave });
          }

                    function confirmAssignDirectAction(pass) {
                        if (pass == 'CLOSE' || pass == undefined) {
                            return;
                        }

                        var isShowInCrewPortal = false;
                        var forceAssignLeave = false;
                        if (pass == 'YES') {
                            isShowInCrewPortal = true;
                            forceAssignLeave = true;
                        }
                        CrewingHelper.assignDirectEvent(
                            crewInfo.crewProfileId,
                            eventType,
                            crewInfo.startDate,
                            crewInfo.endDate,
                            false,
                            isShowInCrewPortal,
                            function (data) {
                                if (data.success) {
                                    //loadActualSchedule(false, undefined, 'Y');
                                    switch (eventType) {
                                        case crewingConstants.EVENT_TYPES.blockDays:
                                            {
                                                createLocalStorageVariable(param.crewId);
                                                MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_BLOCK_DAYS_SUCCESS);
                                                break;
                                            }
                                        case crewingConstants.EVENT_TYPES.off:
                                            {
                                                createLocalStorageVariable(param.crewId);
                                                MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_OFF_SUCCESS);
                                                break;
                                            }
          case crewingConstants.EVENT_TYPES.vulvLeave:
            {
              createLocalStorageVariable(param.crewId);
              MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_VULV_SUCCESS);
              break;
            }
          case crewingConstants.EVENT_TYPES.sickLeave:
            {
              createLocalStorageVariable(param.crewId);
              MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_SICK_LEAVE_SUCCESS);
              break;
            }
          case crewingConstants.EVENT_TYPES.annualLeave:
            {
              createLocalStorageVariable(param.crewId);
              MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_ANNUAL_LEAVE_SUCCESS);
              break;
            } case crewingConstants.EVENT_TYPES.cnt:
            {
              createLocalStorageVariable(param.crewId);
              MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_CNT_SUCCESS);
              break;
            }case crewingConstants.EVENT_TYPES.officeDuty:
              {
                createLocalStorageVariable(param.crewId);
                MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);
                break;
              }

              case crewingConstants.EVENT_TYPES.awbLeave:
                    {
                      createLocalStorageVariable(param.crewId);
                      MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_AWB_SUCCESS);
                      break;
              }

              case crewingConstants.EVENT_TYPES.wfdLeave:
                   {
                      createLocalStorageVariable(param.crewId);
                      MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_WFD_SUCCESS);
                      break;
                   }

              case crewingConstants.EVENT_TYPES.limLeave:
                   {
                       createLocalStorageVariable(param.crewId);
                       MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_LIM_SUCCESS);
                       break;
                   }

              }
          //updateSelectedCrew([param.crewId]);
          loadActualSchedule(false, undefined, 'Y');
        }
      },
      function (error) {
        MessageService.error(error);
      },
      crewInfo.isCustomSelectedDates,
      crewInfo.customSelectedDates,
      forceAssignLeave,
      false,
      crewInfo.selectedBase
    );
}
}

function onAssignSickLeaveListener(data) {
  var _param = getContextMenuClickData(data);
  vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.sickLeave })
}

function onAssignAnnualLeaveListener(data) {
  var _param = getContextMenuClickData(data);
  vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.annualLeave })
}


function onAssignAWBLeaveListener(data) {
     var _param = getContextMenuClickData(data);
     vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.awbLeave })
 }


function onAssignLIMLeaveListener(data) {
    var _param = getContextMenuClickData(data);
    vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.limLeave })
}

function onAssignVUNPLeaveListener(data) {
    var _param = getContextMenuClickData(data);
    vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.vunpLeave })
}

function onAssignSBDLeaveListener(data) {
    var _param = getContextMenuClickData(data);
    vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.sbdLeave })
}

function onAssignWFDLeaveListener(data) {
     var _param = getContextMenuClickData(data);
     vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.wfdLeave })
}


function delayedReportTimingListener() {
  var selectedDuty = CrewingSelectionHelper.getSelectedDuty();
  var details = {
    title: 'Duty Time Regulator',
    selectedDuty:selectedDuty
  };
  vm.onClickDelayedReportTiming({params:details});

}



function onAssignBlockDaysListener(data) {
  var _param = getContextMenuClickData(data);
  vm.onDirectAction({ param: _param, type: crewingConstants.EVENT_TYPES.blockDays })
}

function contextMenuAssignPairingListener() {
  assignAction(vm.assignActionTypes.PAIRING);
}

function toolbarAssignPairingListener() {
  if(vm.crewDetails.active){
    assignAction(vm.assignActionTypes.PAIRING);
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.INACTIVE_CREW_WARNING);
  }
}

function contextMenuAssignTrainingListener() {
  assignAction(vm.assignActionTypes.TRAINING);
}

function acknowledgeDuty(param) {
  if(!!param) {
     // var daySelection = CrewingSelectionHelper.getSelectedDays();
     var crewSelection = CrewingSelectionHelper.getSelectedCrews();
     var blockSelection = CrewingSelectionHelper.getSelectedBlocks();
     var crewScheduleBlockIdSelection = CrewingSelectionHelper.getSelectedCrewSchduleBlockId();
     // vm.onBlockDelete({ blocks: toBeDeleted });
     vm.onAcknowledgeDuty({ params: {crewDTO: crewSelection[0].crewDTO, blocks: blockSelection[0].events} });
  }
}

function onConvertToSickListener() {
  var blockSelection = CrewingSelectionHelper.getSelectedBlocks();
  var details = {
    crewScheduleBlockId: blockSelection[0].events[0].crewScheduleBlockId

  };
  PopupManager.openModal('SWO_CONVERTION_REMARKS', details);

}

function contextMenuOnAcknowledgeListener() {
  // assignAction("ACKNOWLEDGE");
  var details = {
    title: 'Confirmation',
    messages: ['Selected record will be Acknowledged. Do you wish to Continue?']

  };
  PopupManager.openModal('CONFIRM_DIALOG', details, acknowledgeDuty);
}


function toolbarAssignTrainingListener() {
  if(vm.crewDetails.active){
    assignAction(vm.assignActionTypes.TRAINING);
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.INACTIVE_CREW_WARNING);
  }
}

function getSelectedDayAndCrew() {
  var daySelection = CrewingSelectionHelper.getSelectedDays();
  var crewSelection = CrewingSelectionHelper.getSelectedCrews();
  var blockSelection = CrewingSelectionHelper.getSelectedBlocks();
  var crewScheduleBlockIdSelection = CrewingSelectionHelper.getSelectedCrewSchduleBlockId();
  //var selectedDuty = CrewingSelectionHelper.getSelectedDuty();
  var selectedWeek = CrewingSelectionHelper.getWeekData();

  var selectedEvent = null;
  if (blockSelection.length === 1) {
    if ((blockSelection[0].events.length > 0) && (blockSelection[0].events[0]["evenCode"] == "SBY" || blockSelection[0].events[0]["evenCode"] == "HSBY" || blockSelection[0].events[0]["evenCode"] == "ASBY") ) {
      selectedEvent = blockSelection[0].events[0]
    }
  }

  if (daySelection && daySelection.length > 0 && selectedWeek && selectedWeek.length > 0) {
    var _params = {
      day: daySelection,
      crew: crewSelection,
      week: selectedWeek,
      event: selectedEvent,
      crewScheduleBlockId: crewScheduleBlockIdSelection
    };
    return _params;
  }
  return null;
}

function assignAction(type) {

  var _params = getSelectedDayAndCrew()
  if (_params !== null) {
    CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.WEEK, CrewingSelectionHelper.INTERACTION.EXPAND, {
      crews: _params.crew[0],
      week: _params.week[0]
    });

    _params.container = '#crewName_pairing_assign';
    //_params.container = '#crewName_' + _params.crew[0].crewId + '_' + vm.selectetRowIndex;
    vm.isExpandName = true;
    vm.day_height = (Math.floor(vm.actual_screen_height / 6)) * 0.5;
    vm.block_height = Math.floor(vm.day_height * 35 / 100);
    vm.act_she_top_pos = vm.day_height - vm.block_height;
    vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;

    switch (type) {
      case vm.assignActionTypes.PAIRING:
      {
        vm.onAssignPairing({ params: _params });
        break;
      }
      case vm.assignActionTypes.TRAINING:
      {
        vm.onAssignTraining({ params: _params });
        break;
      }
      case vm.assignActionTypes.EVENT:
      {
        vm.onAssignEvent({ params: _params });
        break;
      }
    }

  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
  }
}

function emailCrewScheduleListener() {
  if (!!vm.crewActualSchedule) {
    var details = {
      title: 'Confirmation',
      messages: ['Do you want to send Crew Schedule as an Email?']

    };
    PopupManager.openModal('CONFIRM_DIALOG', details, emailSchedule);

  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
  }
}

function emailSchedule(param) {
  if (!!param) {
    var _param = {
      crews: vm.crewActualSchedule.schedule[0]
    };
    vm.onEmailCrewSchedule.call(this, { params: _param });
  }
}

/*
 function onSendSmsListener() {
 var _param = getSelectedFirstDayAndFirstCrew();
 if (_param !== null) {
 vm.onSendSms.call(this, {param: _param});
 } else {
 MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
 }
 }*/

function onEvaluateTrainingsListener() {
  var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();

  var params = {};
  var blocks = [];
  angular.forEach(selectedBlocks[0].events, function (event) {
    if (event.type !== 'REST') {
      blocks.push(event);
    }
  });

  params.blockInfo = blocks;

  vm.onEvaluateTrainings.call(this, {param: params});
}

function onSendSmsListener() {
  var selectedDays = CrewingSelectionHelper.getSelectedDays();
  var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
  if (selectedDays.length != 0) {
    var params = getSelectedFirstDayAndFirstCrew();
    params.isForDay = true;
    if (params !== null) {
      vm.onSendSms.call(this, { param: params });
    }
  } else if (selectedBlocks.length != 0) {
    var params = selectedBlocks[0].events[0];
    if (params.eventCategory === "LEAVE") {
      MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
      return;
    }
    params.isForBlock = true;
    CrewingHelper.getJoiningCrewList(params.crewScheduleBlockId,!!params.patternId,
      function (crews) {
        params.joiningCrew = crews.joiningCrewDTOS;
        vm.onSendSms.call(this, { param: params });
      },
      function (error) {
        MessageService.error(error);
      });
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
  }
}

function onSendNotificationListener() {
  var selectedDays = CrewingSelectionHelper.getSelectedDays();
  var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
  if (selectedDays.length != 0) {
    var params = getSelectedFirstDayAndFirstCrew();
    params.isForDay = true;
    if (params !== null) {
      vm.onSendSms.call(this, { param: params });
    }
  } else if (selectedBlocks.length != 0) {
    var params = selectedBlocks[0].events[0];
    if (params.eventCategory === "LEAVE") {
      MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
      return;
    }
    params.isForBlock = true;
    CrewingHelper.getJoiningCrewList(params.crewScheduleBlockId,!!params.patternId,
      function (crews) {
        params.joiningCrew = crews.joiningCrewDTOS;
        PopupManager.openModal('SEND_NOTIFICATION', params);
      },
      function (error) {
        MessageService.error(error);
      });
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
  }
}

function sendAlertListener() {
  var _param = getSelectedFirstDayAndFirstCrew();
  if (_param !== null) {
    vm.onSendAlert({ param: _param });
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
  }
}

function historyListener() {
  var _param = getSelectedFirstDayAndFirstCrew();
  if (_param !== null) {
    vm.onShowHistory.call(this, { params: _param });
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
  }
}

function regulationDetailsListener() {
  var crewSelection = CrewingSelectionHelper.getSelectedCrews();
  var selectedDuty = CrewingSelectionHelper.getSelectedDuty();


  if (!!selectedDuty) {
    var _param = {
      crew: crewSelection[0],
      block: selectedDuty
    };
    vm.onShowRegulations.call(this, { params: _param });
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
  }
}

function paxMsgDetailsListener() {
  var crewSelection = CrewingSelectionHelper.getSelectedCrews();
  var selectedDuty = CrewingSelectionHelper.getSelectedDuty();


  if (!!selectedDuty) {
    var _param = {
      crew: crewSelection[0],
      block: selectedDuty
    };
    vm.onShowPaxMsgDet.call(this, { params: _param });
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
  }

}

function showAllCrewsInScheduleListener() {
  var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
  if (selectedBlocks.length > 0) {
    var _param = {
      block: selectedBlocks[0]
    };
    vm.onShowAllCrewsInSchedule.call(this, { params: _param });
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
  }
}

function deselectAll() {
  CrewingSelectionHelper.clearSelections();
}

function editPairingListener() {
  var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
  var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
  if(vm.crewDetails.active){
    if (!!selectedCrews.length && !!selectedBlocks.length) {
      /* var tmpParam = {
       crew: selectedCrews[0],
       block: selectedBlocks[0]
       };
       vm.onEditPairing({params: tmpParam});*/
      if (selectedBlocks.length > 1) {
        MessageService.warning(MessageService.MESSAGES.CREWING.OPERATION_NOT_SUPPORTED_FOR_MULTIPLE_BLOCKS);
      } else {
        var block = selectedBlocks[0];
        if (!!block.patternId) {
          var tmpParam = {
            crew: selectedCrews[0],
            block: selectedBlocks[0]
          };
          localStorage.setItem("crewList", tmpParam.crew.crewId);
          vm.onEditPairing({ params: tmpParam });
        } else {
          MessageService.warning(MessageService.MESSAGES.CREWING.BLOCK_NOT_PART_OF_A_PATTERN);
        }
      }

    } else {
      MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
    }
  } else {
    MessageService.warning(MessageService.MESSAGES.CREWING.INACTIVE_CREW_WARNING);
  }



}

vm.moveOnExpiry = function (e, expiryDetails) {
  var findCheckPosition = function () {
    var H = 'left', V = 'top';
    if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
      H = 'left';
    } else {
      H = 'right';
    }
    if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
      V = 'bottom';
    } else {
      V = 'top';
    }check
    return H + '-' + V;
  };
  vm.expiryToolTipModel = expiryDetails;
  vm.expiryToolTipModel.placement = findCheckPosition();
};

vm.onExpiryClick = function (expiryDetails) {
  var param = {
    expiryInfo: { 'EXPIRY': expiryDetails }
  };
  PopupManager.openModal('SHOW_EXPIRY', param);

};

vm.moveOnAlert = function (e, alertDetails) {
  var findCheckPosition = function () {
    var H = 'left', V = 'top';
    if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
      H = 'left';
    } else {
      H = 'right';
    }
    if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
      V = 'bottom';
    } else {
      V = 'top';
    }
    return H + '-' + V;
  };
  vm.expiryToolTipModel = alertDetails;
  vm.expiryToolTipModel.placement = findCheckPosition();
};

vm.onAlertClick = function (alertDetails) {
  var params = {
    fromDate: alertDetails,
    toDate: alertDetails
  };
  var tabName = 'alertManager';
  StorageServices.setTabData(tabName, 'alertParams', params);
  var currentTab = ApplicationService.getSelectedTab();
  if (currentTab !== tabName) {
    TabService.gotoTab(tabName);
  }

};
function loadUserPreferencesForRightClickLeaveAssignment() {
  CommonMasterData.getRightClickLeaveAssignmentOptions(function(preferencesList) {
    angular.forEach(preferencesList, function (option) {
      const event = getEventFromCode(option.eventCode);

      EventManagerService.registerEventListener(event, function (data) {

          var _param = getContextMenuClickData(data);

          vm.onDirectAction({
              param: _param,
              type: option.eventCode
          });

      });

  });


  }, function () {
    console.log('Right Click User Leave Preferences Retrieval Eroor!!!');
  });
}

function loadUserPreferencesForRightClickEventAssignment() {
  CommonMasterData.getRightClickEventAssignmentOptions(function(preferencesList) {
    angular.forEach(preferencesList, function (option) {
          const event = getEventFromCode(option.eventCode);

          EventManagerService.registerEventListener(event, function (data) {

              var _param = getContextMenuClickData(data);

              vm.onDirectAction({
                  param: _param,
                  type: option.eventCode
              });

          });

      });
  }, function () {
    console.log('Right Click User Event Preferences Retrieval Eroor!!!');
  });
}

function getEventFromCode(code){
    return  'event.context_menu.assign_' + code;
};

function changeScreenListener() {

  $timeout(function () {
    if (window.innerHeight === screen.height) {
      vm.actual_screen_height = window.innerHeight - 160; // 120 = header banners height + legend height
    }
    else {
      vm.actual_screen_height = window.innerHeight - 235; // 235 = header banners height + legend height
    }
    vm.day_height = Math.floor(vm.actual_screen_height / 6);
    vm.block_height = Math.floor(vm.day_height * 35 / 100);
    vm.act_she_top_pos = vm.day_height - vm.block_height;
    vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;

  }, 500);

}

vm.onDoubleClickBlock = function () {
  editBlockListener();
};
},
bindings: {
  fromDate: '<',
    toDate: '<',
    weekDays: '<',
    crewActualSchedule: '<',
    alertsDetails: '<',
    memoDetails: '<',
    viewMode: '<',
    crewPublishSchedule: '<',
    monthNavigation: '&',
    crewDetails: '<',
    onAddMemo: '&',
    onEditBlock: '&',
    onAssignEvent: '&',
    onDirectAction: '&',
    onBlockDelete: '&',
    onAcknowledgeDuty: '&',
    onConvertBackToSick: '&',
    onAssignPairing: '&',
    onReplacePairing: '&',
    onAssignTraining: '&',
    onEmailCrewSchedule: '&',
    retrieveTrainingsInfo: '&',
    onEvaluateTrainings: '&',
    onSendSms: '&',
    onSendAlert: '&',
    onShowHistory: '&',
    onShowRegulations: '&',
    onShowPaxMsgDet: '&',
    onShowAllCrewsInSchedule: '&',
    onEditPairing: '&',
    showingCrewProfile: '=',
    fdpPendingBlocks: '=',
    warnings: '=',
    onSbyCallout: '&',
    onClickDelayedReportTiming: '&'
}
});
})();
